
import { faEdit, faPlus, faSave, faTrash } from "@fortawesome/free-solid-svg-icons";
import "./SrvButtonLink.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function SrvButtonLink({ typeBtn, textBtn, onClick }) {
  /*
  type:
   add - Добавление
   edit - Редактирование
   remove - Удаление
   save - сохранение
  */

    return (
      
         <>
         {typeBtn === "add" && (
            <div className="srv_button_link" onClick={onClick}>
               <i className="mr-5"><FontAwesomeIcon icon={faPlus} /></i>
               {textBtn === undefined ? 'Добавить' : textBtn}
            </div>      
         )}
         {typeBtn ==="edit" && (
             <div className="srv_button_link" onClick={onClick}>
                <i className="mr-5"><FontAwesomeIcon icon={faEdit} /></i>
                {textBtn === undefined ? 'Изменить' : textBtn}
             </div>
         )}
         {typeBtn ==="remove" && (
             <div className="srv_button_link" onClick={onClick}>
                <i className="mr-5"><FontAwesomeIcon icon={faTrash} /></i>
                {textBtn === undefined ? 'Удалить' : textBtn}
             </div>       
         )}
          {typeBtn ==="save" && (
             <div className="srv_button_link" onClick={onClick}>
                <i className="mr-5"><FontAwesomeIcon icon={faSave} /></i>
                {textBtn === undefined ? 'Сохранить' : textBtn}
             </div> 
         )}
       </>                  
    )
}

export default SrvButtonLink;